import { mount } from "svelte";
import "./styles/global.scss";
import FloatingActionButton from "./components/pages/FloatingActionButton.svelte";
import { AuthenticationTokenService } from "./lib/AuthenticationTokenService";
import { ShopIntegrationService } from "./lib/ShopIntegrationService";
import { tracking } from "./lib/Tracking";

const target = document.getElementById("cassandra-floating-btn");
const shopIntegration = new ShopIntegrationService();

(async () => {
    if (!target) {
        return;
    }

    const [canShowChatbotEntrypoint, isLoggedInUserInApp, isInOnexTestGroup] = await Promise.all([
        shopIntegration.canShowChatbotEntrypoint(),
        shopIntegration.isLoggedInUserInApp(),
        shopIntegration.isInOnexTestGroup(),
    ]);

    const showFloatingActionButton = (isLoggedInUserInApp && isInOnexTestGroup) || AuthenticationTokenService.hasToken();
    if (canShowChatbotEntrypoint) {
        if (isLoggedInUserInApp) {
            tracking.submitMerge({
                san_ChatBotView: ["true"],
            });
        }

        if (showFloatingActionButton) {
            mount(FloatingActionButton, {
                target,
                props: { href: "/chat" },
            });
        }
    }
})();
